"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectGlobalListViewTypeOption')(function selectGlobalListViewTypeOption(selection, state) {
    var optionState = state.optionState;
    optionState.globalListViewType = selection;
}));
//# sourceMappingURL=selectGlobalListViewTypeOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/actions/selectGlobalListViewTypeOption.js
// module id = 5069
// module chunks = 2